// extracted by mini-css-extract-plugin
export default {"container":"LC-z","dimension":"MC-z","dimensionLabels":"NC-z"};